module.exports = __webpack_public_path__ + "static/media/sg14cr0.6bf04db9.png";